<draggable-container [ngClass]="{'stand-out':focusMode}" [prefix]="data.prefix">
  <div id="{{data.prefix}}-quiz">
    <div class="answers-alert" *ngIf="focusMode">
      <small>
        <strong>
          Debes marcar como correcta al menos una opción
        </strong>
      </small>
    </div>
    <label class="me-1" [for]="data.prefix+'questionBox'">Enunciado</label>
    <textarea name="text" class="form-control mb-1" [id]="data.prefix+'questionBox'"
      [(ngModel)]="data.question"></textarea>
    <div *ngIf="data.test">
        <div class="d-flex flex-column justify-content-center">
          <div class="pb-1" *ngFor="let answer of data.answers; let i=index">
            <div class="input-group">
              <input type="checkbox" [name]="data.prefix+i+'answer'" [id]="data.prefix+i+'answer'"
                (change)="checkIsCorrectionMissing()" class="form-check-input"
                [id]="data.prefix+i+'checkbox'" [(ngModel)]="answer.correct"/>
              <input type="text" class="form-control me-2" [(ngModel)]="answer.text" [ngClass]="{'answer-correct': answer.correct}"
               [name]="data.prefix+i+'answer'" [id]="data.prefix+'-'+i+'answer'" (focusout)="checkAnswerEmpty($event, i)">
              <div class="input-group-append">
                <button class="btn btn-sm btn-outline-danger" type="button" (click)="deleteAnswer(i)"
                [disabled]="data.answers.length <= 2">
                  <i class="fa-solid fa-trash"></i>
                </button>
              </div>
            </div>
          </div>
          <input type="text" class="form-control" placeholder="Añadir opción"
          (click)="onNewAnswerInput()" [id]="data.prefix+'-'+data.answers.length+'ansswer'">
          <!--<button *ngIf="data.answers.length < 10" class="btn btn-levelab" (click)="addAnswer()">
            <small>
              <i class="fa-solid fa-plus"></i>&nbsp;Añadir opción
            </small>
          </button>-->
        </div>
    </div>
  </div>
</draggable-container>
<div class="overlay" [ngStyle]="{'display':focusMode?'block':'none'}"> </div>